const { StyleSheet } = require('@react-pdf/renderer');

const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerWrapper: {
    flexDirection: 'column',
    alignItems: 'stretch',
    marginBottom: 25
  },
  heading: {
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
    color: '#4F4F4F'
  },
  logo: {
    width: '90px',
    height: '45px',
    objectFit: 'contain'
  },
  date: {
    fontSize: 8,
    color: '#000',
    marginRight: 10
  },
  divider: {
    borderBottomColor: 'black',
    borderBottomWidth: 1
  },
  key: {
    fontSize: 10,
    color: 'gray'
  },
  value: {
    fontSize: 10,
    color: 'black'
  },
  summary: {
    marginBottom: 40,
    marginLeft: 10,
    marginRight: 10
  },
  summaryHeading: {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 15
  },
  keyValueContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 15
  },
  keyValueRow: {
    width: '50%',
    flexDirection: 'row',
    marginBottom: 5
  },
  timeline: {
    marginBottom: 20,
    marginLeft: 10,
    marginRight: 10
  },
  timelineHeading: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 15
  },

  table: {
    display: 'table',
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableCell: {
    flex: 1,
    padding: 5,
    fontSize: 8,
    fontWeight: 'normal',
    wordWrap: 'break-word'
  },
  tableCellSmall: {
    flex: 0.5,
    padding: 5,
    fontSize: 8,
    fontWeight: 'normal',
    wordWrap: 'break-word'
  },

  tableHeaderCell: {
    flex: 2,
    padding: 5,
    fontSize: 8,
    fontWeight: 'bold'
  }
});

export default pdfStyles;
